<template>
    <v-card color="#F4FEFB">
        <v-card-title>
            入力欄の設定
        </v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <badge-component tile content="必 須" color="red">
                  <label-component>入力者</label-component>
              </badge-component>
              <v-select
                :items="selectDestinations"
                outlined
                hide-details
                v-on:change="changeUserId"
                v-model="selected"
                background-color="white"
              >
              </v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <badge-component tile content="任 意">
                  <label-component>ラベル</label-component>
              </badge-component>
              <v-text-field
                v-model="label"
                outlined
                hide-details
                v-on:blur="changeLabel"
                background-color="white"
              >
              </v-text-field>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <badge-component tile :content="content" :color="contentColor">
                  <label-component>項目</label-component>
              </badge-component>
              <v-menu
                  v-model="selectMenu"
                  :close-on-content-click="false"
                  origin="center center"
                  class="input_field_dialog"
                  right
                  nudge-top="200"
                  nudge-right="250"
                  max-height="300"
                  max-width="260"
                  width="auto"
              >
              <template v-slot:activator="{ on, attrs }">
                  <v-btn block
                        color="red"
                        class="white--text"
                        v-bind="attrs"
                        v-on="on">
                        編集・追加
                  </v-btn>
              </template>
              <v-card color="#F4FEFB">
                  <v-card-title>
                      項目設定
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-alert v-if="show" type="error">
                    すでに入力されています。
                  </v-alert>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <div class="wapper">
                          <v-text-field
                            v-model="selectItem"
                            outlined
                            hide-details
                            background-color="white"
                            :maxlength="255"
                          >
                          </v-text-field>
                          <v-btn block color="orange" class="btn white--text" :disabled="invalid" v-on:click="addSelectItem" >
                              <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                    <draggable
                      :list="items"
                    >
                    <v-list-item
                      v-for="item,index in items"
                      :key="index"
                      :input-value="item"
                    >
                      <div class="wapper">
                        <v-icon class="arrow-icon" >mdi-drag-horizontal-variant</v-icon>
                        <v-list-item-title v-text="item" style="width:135px;margin-left:15px;"></v-list-item-title>
                        <v-btn block color="orange" :value="item" class="btn white--text" v-on:click="delSelectItem" >
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </div>
                    </v-list-item>
                    </draggable>
                  </v-list>
              </v-card>
              </v-menu>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card>
</template>

<script>
import draggable from 'vuedraggable'
export default {
    components:{
        draggable,           // ドラッグ＆ドロップ
    },
    props: ['destinations', 'destinationId','items','currentValue','currentLabel','type'],
    data: function () {
        return {
            selectDestinations: [],
            label: "",
            selectItem: "",
            selected: 0,
            selectMenu: false,
            invalid: false,
            show: false,
            maxItems: 50,
            content: "必 須",
            contentColor: "red"
        };
    },
    created: function () {
        this.selected = this.destinationId;
        this.label = this.currentLabel?? '';
        Object.entries(this.destinations).forEach((val, index) => {
            this.selectDestinations.push({
                text: val[1].destination_user_name,
                value: val[1].id
            });
        });
        if(this.items.length >= this.maxItems){
          this.invalid = true
        }
        if(this.type == "template"){
          this.content = "任 意"
          this.contentColor = "grey lighten-1"
        }
    },
    methods: {
      changeUserId: function (e) {
        this.$emit('changeUserId', e);
      },
      changeLabel: function (e) {
        this.$emit('changeLabel', e.target.value);
      },
      addSelectItem: function () {
        var obj = this.selectItem.trim();
        if(typeof obj != "undefined" && obj != null && obj != ""){
          var index = this.items.indexOf(obj)
          if(index == -1){
            this.$emit('addSelectItem', this.selectItem);
            this.selectItem = "";
            this.show = false;
          }else{
            this.show = true;
          }
          
          if(this.items.length >= this.maxItems){
            this.invalid = true
          }
        }
      },
      delSelectItem: function (e) {
        this.$emit('delSelectItem', e.currentTarget.getAttribute('value'));
        if(this.items.length <= this.maxItems){
          this.invalid = false
        }
      },
    },
    watch: {
      items: function(newVal, oldVal) {
        if(this.items.length >= this.maxItems){
          this.invalid = true
        }else{
          this.invalid = false
        }
      }
    },
};
</script>

<style scoped>
    .wapper {
        display: flex;
    }
    .btn {
        width: 32px !important;
        min-width: 32px !important;
        max-width: 32px !important;
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        margin: auto 0;
        margin-left: 5px;
    }
    .v-alert{
      margin-bottom:-10px;
      font-size:14px;
    }
</style>